"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class AnalyzeQueryRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsUUID)('4'),
    (0, base_models_1.Docs)({ example: '622cca53-bcc3-43a9-8f83-fd7ca0ab62c3', description: 'Profile ID of the customer/prospect.' }),
    tslib_1.__metadata("design:type", String)
], AnalyzeQueryRequest.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '23543', description: 'CDT ID of the campaign.' }),
    tslib_1.__metadata("design:type", String)
], AnalyzeQueryRequest.prototype, "cdtId", void 0);
exports.default = AnalyzeQueryRequest;
